import { WarningAmber } from "@mui/icons-material";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { useIsUserRoleFromOtherCompany } from "./use-is-user-role-from-other-company";

export const UserRoleOtherCompanyWarning: FC<{ roleId?: number }> = ({
  roleId,
}) => {
  useTranslation();
  const isOtherCompanyRole = useIsUserRoleFromOtherCompany(roleId);

  if (!isOtherCompanyRole) {
    return null;
  }

  return (
    // tooltip now is disabled - left for future use if needed
    // <FramerTooltip content={t("role.BELONGS_TO_OTHER_COMPANY")}>
    <span
      className="userRoles-item__other-company-warning"
      data-e2e="user-role-other-company-warning"
    >
      <WarningAmber color="warning" fontSize="small" />
    </span>
    // </FramerTooltip>
  );
};
